var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { LayoutsListItem } from "@/components/studio/studio/components/layouts/layoutsListItem";
import { useGetModuleBuilderLayoutsQuery } from "@/store/api";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { LayoutEditor } from "./_layout";
export var Layouts = function () {
    var t = useTranslation(["ModuleBuilder"]).t;
    var _a = useParams(), packagesName = _a.packagesName, moduleName = _a.moduleName, type = _a.type, menu = _a.menu, dropdownName = _a.dropdownName, fieldName = _a.fieldName;
    var _b = useGetModuleBuilderLayoutsQuery({
        params: {
            package: "",
            module: moduleName,
        },
    }), list_layouts = _b.data, isLoading = _b.isLoading;
    var _c = useState([]), layouts = _c[0], setLayouts = _c[1];
    var fetchLayouts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            if (list_layouts) {
                setLayouts((_a = list_layouts === null || list_layouts === void 0 ? void 0 : list_layouts.data) === null || _a === void 0 ? void 0 : _a.layouts);
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        fetchLayouts();
    }, [list_layouts]);
    var mbRoot = "modules/ModuleBuilder";
    var MainContent = function () {
        return (_jsx("div", __assign({ className: "flex flex-col" }, { children: _jsx("div", __assign({ className: "flex flex-col" }, { children: _jsx("div", __assign({ className: "card w-full h-full flex flex-col" }, { children: _jsx("div", __assign({ className: "card-content flex-1 overflow-hidden" }, { children: _jsxs("div", __assign({ className: "content w-full h-full flex flex-col" }, { children: [_jsx("div", __assign({ className: "py-1" }, { children: _jsx(Link, __assign({ to: "new", className: "bg-[var(--color-brand-primary)] text-white py-2 px-2 rounded text-sm" }, { children: t("LBL_ADD_LAYOUT", { ns: "ModuleBuilder" }) })) })), _jsx("div", __assign({ className: "flex flex-col flex-1" }, { children: _jsx("div", __assign({ className: "flex flex-col" }, { children: _jsx("div", __assign({ className: "flex justify-center items-center" }, { children: _jsx("div", __assign({ className: "w-full md:w-1/2" }, { children: _jsx("div", __assign({ className: "border rounded-md shadow-md" }, { children: packagesName &&
                                                        moduleName &&
                                                        Object.entries(layouts).map(function (_a) {
                                                            var name = _a[0], meta = _a[1];
                                                            if (name === "popupdefs") {
                                                                return (_jsx(LayoutsListItem, { layoutKey: name, layoutMeta: __assign(__assign({}, meta), { hasChildren: true }), packageName: packagesName, moduleName: moduleName }, name));
                                                            }
                                                            return (_jsx(LayoutsListItem, { layoutKey: name, layoutMeta: meta, packageName: packagesName, moduleName: moduleName }, name));
                                                        }) })) })) })) })) }))] })) })) })) })) })));
    };
    return _jsx(_Fragment, { children: fieldName ? _jsx(LayoutEditor, {}) : _jsx(MainContent, {}) });
};
